export default "__VITE_ASSET__DiSA_R5a__"